import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import Filter from "../modules/Filter";
// import { getCardTypesWithoutPagination } from "layouts/card_type/services/cardTypeService";
import { getPerFilter, getPerFilterPerFile } from "../services/filterService";
import { v4 as uuidv4 } from "uuid";
import { MenuItem } from "@mui/material";
import { CategoriesListAllService } from "../../../layouts/activities/services/ActivitiesServices";
// import { getStatusTypes } from "layouts/card/services/cardService";
// import { getSourceTypes } from "layouts/sources_data/services/dataSourceService";
const FilterController = forwardRef(
  (
    {
      setListData,
      dataFilter,
      filterConfig,
      dataTable,
      setTotalPages,
      setCurrentPage,
      currentPage,
      requestData,
      setError = () => { },
      setTotalData,
      setEntriesEnd,
      setEntriesStart,
      dataSourceId,
      setLoading = () => { },
      activity_id,
      handleAlert = () => { },
      viewListActivity,
      upload_id,
      gendersList = [],
      specialProtectionGroupsList = [],
      category_id,
      nodesList = [],
      usersList = [],
      getNodeStatusOptions = () => [],
    },
    ref
  ) => {
    // const filterConfig = [
    //   { visibleName: "Tipo de Carnet", dbField: "type_carnet", type: "select", source: "cardType" },
    //   { visibleName: "Estado", dbField: "status", type: "select", source: "status" },
    //   { visibleName: "Fuente", dbField: "source_type_name", type: "select", source: "sourceTypes" },
    //   { visibleName: "Documento", dbField: "number_id", type: "text" },
    //   { visibleName: "Nombre", dbField: "name", type: "text" },
    //   { visibleName: "Correo Electrónico", dbField: "email", type: "text" },
    //   { visibleName: "Fecha de Creación", dbField: "created_at", type: "date" },
    //   { visibleName: "Fecha de Actualización", dbField: "updated_at", type: "date" },
    // ];
    //Variables del Filtro  ---->
    const [dataTypeCard, setDataTypeCard] = useState();
    const [dataSourceTypes, setDataSourceTypes] = useState();
    const [categoriesList, setCategoriesList] = useState([]);
    const [subCategoriesList, setSubCategoriesList] = useState([]);
    const [dataStatus, setDataStatus] = useState();
    const [dateFrom, setDateFrom] = useState("date");
    const [search, setSearch] = useState("");
    const [dateUntil, setDateUntil] = useState("date");
    const [filter, setFilter] = useState("");
    const [filterDate, setFilterDate] = useState("");
    const [filterType, setFilterType] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleDate, setIsVisibleDate] = useState(false);
    const [isVisibleType, setIsVisibleType] = useState(false);
    const [isVisibleCategory, setIsVisibleCategory] = useState(false);
    const [isVisibleSubcategory, setIsVisibleSubcategory] = useState(false);
    const [isVisibleCertifiable, setIsVisibleCertifiable] = useState(false);
    const [isVisibleStatus, setIsVisibleStatus] = useState(false);
    const [isVisibleErrorType, setIsVisibleErrorType] = useState(false);
    const [isVisibleSeverity, setIsVisibleSeverity] = useState(false);
    const [isVisibleGender, setIsVisibleGender] = useState(false);
    const [isVisibleSpecialProtectionGroup, setIsVisibleSpecialProtectionGroup] = useState(false);
    const [isVisibleState, setIsVisibleState] = useState(false);
    const statesList = [{ id: "Académico", name: "Académico" }, { id: "Laboral", name: "Laboral" }];
    const [isVisibleSemester, setIsVisibleSemester] = useState(false);
    const [semesterYear, setSemesterYear] = useState("");
    const [semesterPeriod, setSemesterPeriod] = useState("");
    const [isVisibleNode, setIsVisibleNode] = useState(false);
    const [isVisibleAuthor, setIsVisibleAuthor] = useState(false);
    const [isVisibleEnabled, setIsVisibleEnabled] = useState(false);
    const [isVisibleSelectDateInput, setIsVisibleSelectDateInput] = useState(false);
    const [isVisibleSelectDate, setIsVisibleSelectDate] = useState(false);
    const [filters, setFilters] = useState([]);
    const [table, setTable] = useState(dataTable);
    const [ShowErrorAlert, setShowErrorAlert] = useState(true);
    const [paginaSize, setPaginaSize] = useState(10);
    // const [isSubmitted, setIsSubmitted] = useState(false);

    // Ejecutar función requestCarnetsDate con el arreglo de filtros
    const searchValidation = async (
      currentPage,
      pageSize,
      exportExcel,
      passedFilters = filters
    ) => {
      if (dataSourceId) {
        requestFilterPerIdFile(dataSourceId, currentPage, pageSize, passedFilters);
      } else {
        await requestFilter(currentPage, pageSize, passedFilters, activity_id, exportExcel);
      }
    };

    // Esperar respuesta de la función getCarnePerFilterDate con los parametros de filtro, tabla filtrad y variables del renderizado
    const requestFilter = async (pageIndex, pageSize, filters, activity_id, exportExcel) => {
      try {
        let activity_id_finally;
        if (activity_id) {
          activity_id_finally = activity_id.replace(/-/g, "");
        }
        const result = await getPerFilter(
          pageIndex,
          pageSize,
          filters,
          table,
          activity_id_finally,
          exportExcel,
          viewListActivity,
          upload_id,
          category_id
        );

        // Verificar si result es una Response (tiene headers)
        if (result && result.headers) {
          const contentType = result.headers.get("Content-Type");
          if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            const blob = await result.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "export.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            handleAlert("success", "Exportación exitosa");
          } else {
            const resultResponse = await result.json();
            if (resultResponse && resultResponse.success !== false) {
              const { data, last_page, total, from, to } = resultResponse.payload;
              await setListData(data);
              await setTotalPages(last_page);
              if (last_page <= pageIndex) {
                await setCurrentPage(last_page);
              }
              await setTotalData(total);
              await setEntriesStart(from);
              await setEntriesEnd(to);
              setLoading(false);
              setError("");
            } else {
              setLoading(false);
              handleAlert("fail", resultResponse.message || "Error al procesar la solicitud");
            }
          }
        } else {
          setLoading(false);
          handleAlert("fail", result?.message || "Fallo al realizar la solicitud");
        }
      } catch (error) {
        setLoading(false);
        handleAlert("fail", error.message || "Error al procesar la respuesta del servidor");
      }
    };

    // Esperar respuesta de la función getCarnePerFilterDate con los parametros de filtro, tabla filtrad y variables del renderizado
    const requestFilterPerIdFile = async (id, pageIndex, pageSize, filters) => {
      try {
        const result = await getPerFilterPerFile(id, pageIndex, pageSize, filters, dataTable);

        if (result.status !== false) {
          const { data, last_page, total, from, to } = result;
          await setListData(data);
          await setTotalPages(last_page);
          if (last_page <= pageIndex) {
            await setCurrentPage(last_page);
          }
          await setTotalData(total);
          await setEntriesStart(from);
          await setEntriesEnd(to);
          setLoading(false);
          setError("");
        } else {
          setLoading(false);
          setError("Error al consultar al servidor");
        }
      } catch (error) {
        setLoading(false);
      }
    };

    //Controla el comportamiento de los filtros segun cual sea elegido
    const handleFilter = (event) => {
      const selectedFilter = filterConfig.find((f) => f.dbField === event.target.value);

      if (event.target.value === "") {
        setFilters([]); // Limpiamos todos los filtros
        // setSubCategoriesList([]);
        // setCategoriesList([]);
        setIsVisible(false); // Ocultamos input de texto
        setIsVisibleType(false); // Ocultamos input de tipo select
        setIsVisibleSelectDate(false); // Ocultamos inputs de fecha
        setIsVisibleSelectDateInput(false); // Asegúrate de ocultar el input de fecha
        setIsVisibleSubcategory(false); // asegurate de ocultar el select de subcategoria
        setIsVisibleCertifiable(false); // asegurate de ocultar el select de subcategoria)
        setIsVisibleCategory(false); // asegúrate de ocultar el select de categoria
        setIsVisibleStatus(false); // asegúrate de ocultar el select de status
        setIsVisibleErrorType(false); // asegúrate de ocultar el select de error type
        setIsVisibleSeverity(false); // asegúrate de ocultar el select de severity
        setIsVisibleGender(false); // asegúrate de ocultar el select de género
        setIsVisibleSpecialProtectionGroup(false); // asegúrate de ocultar el select de grupos especiales
        setIsVisibleState(false); // asegúrate de ocultar el select de estado
        setIsVisibleSemester(false); // asegúrate de ocultar el select de semestre
        setSemesterYear(""); // Limpiar año del semestre
        setSemesterPeriod(""); // Limpiar período del semestre
        setIsVisibleNode(false); // asegúrate de ocultar el select de nodo
        setIsVisibleAuthor(false); // asegúrate de ocultar el select de autor
        setIsVisibleEnabled(false); // asegúrate de ocultar el select de enabled
        setSearch(""); // Limpiamos el valor de búsqueda
        setDateFrom("date"); // Limpiamos el campo de fecha desde
        setDateUntil("date"); // Limpiamos el campo de fecha hasta
        setFilter(""); // Limpiamos el filtro seleccionado
        return;
      }
      if (!selectedFilter) return;

      setFilter(selectedFilter.dbField);

      // Resetear todos los estados de visibilidad primero
      setIsVisible(false);
      setIsVisibleType(false);
      setIsVisibleSelectDate(false);
      setIsVisibleSubcategory(false);
      setIsVisibleCertifiable(false);
      setIsVisibleCategory(false);
      setIsVisibleStatus(false);
      setIsVisibleErrorType(false);
      setIsVisibleSeverity(false);
      setIsVisibleGender(false);
      setIsVisibleSpecialProtectionGroup(false);
      setIsVisibleState(false);
      setIsVisibleSemester(false);
      setIsVisibleNode(false);
      setIsVisibleAuthor(false);
      setIsVisibleEnabled(false);
      setSearch("");

      switch (selectedFilter.type) {
        case "text":
          setIsVisible(true);
          break;
        case "select":
          setIsVisibleType(true);
          // Activar el campo específico según la fuente
          if (selectedFilter.source === "subCategoryTypes") {
            setIsVisibleSubcategory(true);
          } else if (selectedFilter.source === "categoryTypes") {
            setIsVisibleCategory(true);
          } else if (selectedFilter.source === "certifiableTypes") {
            setIsVisibleCertifiable(true);
          } else if (selectedFilter.source === "statusTypes") {
            setIsVisibleStatus(true);
          } else if (selectedFilter.source === "errorTypes") {
            setIsVisibleErrorType(true);
          } else if (selectedFilter.source === "severityTypes") {
            setIsVisibleSeverity(true);
          } else if (selectedFilter.source === "genderTypes") {
            setIsVisibleGender(true);
          } else if (selectedFilter.source === "specialProtectionGroupTypes") {
            setIsVisibleSpecialProtectionGroup(true);
          } else if (selectedFilter.source === "stateTypes") {
            setIsVisibleState(true);
          } else if (selectedFilter.source === "enabledTypes") {
            setIsVisibleEnabled(true);
          } else if (selectedFilter.source === "nodeTypes") {
            setIsVisibleNode(true);
          } else if (selectedFilter.source === "authorTypes") {
            setIsVisibleAuthor(true);
          }
          break;
        case "date":
          setIsVisibleSelectDate(true);
          break;
        case "semester":
          setIsVisibleSemester(true);
          setSemesterYear("");
          setSemesterPeriod("");
          break;
        default:
          resetFieldValid();
          break;
      }
    };

    //Maneja y valida los filtros que se agregan, si ya existe se reemplaza el antiguo por el nuevo
    // const handleAddFilter = () => {
    //   const selectedFilter = filterConfig.find((f) => f.dbField === filter);
    //   if (!selectedFilter || (!search.trim() && filterDate === "")) {
    //     handleChangeValid("search", false);
    //     return;
    //   }

    //   const newFilter = {
    //     id: uuidv4(),
    //     type: selectedFilter.dbField,
    //     value: filter === "date" ? { from: dateFrom, until: dateUntil } : search.trim(),
    //     label: `${selectedFilter.visibleName}: ${
    //       filter === "date" ? `${dateFrom} - ${dateUntil}` : search.trim()
    //     }`,
    //   };

    //   setFilters((prevFilters) => [...prevFilters, newFilter]);
    //   //resetState();
    // };

    const handleAddFilter = () => {
      const selectedFilter = filterConfig.find((f) => f.dbField === filter);

      // Validar que se haya seleccionado un filtro
      if (!selectedFilter) {
        handleChangeValid("search", false);
        return;
      }

      // Validar si el filtro es de tipo texto o fecha
      if (selectedFilter.type === "date") {
        // Verificar que ambos campos de fecha (desde y hasta) tengan valores válidos
        if (dateFrom === "date" || dateUntil === "date" || dateFrom === "" || dateUntil === "") {
          handleChangeValid("date", false);
          return;
        }
      } else if (selectedFilter.type === "semester") {
        // Verificar que se hayan seleccionado año y periodo
        if (!semesterYear || !semesterPeriod) {
          return;
        }
      } else {
        // Validar que el campo de búsqueda no esté vacío para otros tipos de filtros
        if (selectedFilter.type === "select") {
          // Para subcategorías, verificar que sea un array con elementos
          if (selectedFilter.source === "subCategoryTypes") {
            if (!Array.isArray(search) || search.length === 0) {
              return;
            }
          }
          // Para nodos, autores, género, estado y grupos especiales, verificar que sea un objeto con id
          else if (
            selectedFilter.source === "nodeTypes" ||
            selectedFilter.source === "authorTypes" ||
            selectedFilter.source === "genderTypes" ||
            selectedFilter.source === "stateTypes" ||
            selectedFilter.source === "specialProtectionGroupTypes"
          ) {
            if (!search || typeof search !== "object" || !search.id) {
              return;
            }
          }
          // Para otros selects, verificar que no esté vacío
          else if (!search || (typeof search === "string" && search.length === 0)) {
            return;
          }
        } else if (typeof search === "string" && !search.trim()) {
          handleChangeValid("search", false);
          return;
        }
      }
      const newFilter = {
        id: uuidv4(),
        type: selectedFilter.dbField,
        value:
          selectedFilter.type === "date"
            ? { from: dateFrom, until: dateUntil }
            : selectedFilter.type === "semester"
              ? `${semesterYear}-${semesterPeriod}`
              : selectedFilter.type === "select"
                ? selectedFilter.source === "subCategoryTypes"
                  ? search?.map((item) => item.id)
                  : selectedFilter.source === "certifiableTypes"
                    ? search // Aquí guardamos directamente "1" o "0"
                    : selectedFilter.source === "nodeStatus"
                      ? search.id // Para nodos, usar el valor booleano
                      : selectedFilter.source === "nodeTypes"
                        ? search.id // Para filtro de nodos, usar el id del nodo
                        : selectedFilter.source === "authorTypes"
                          ? search.id // Para filtro de autores, usar el id del autor
                          : selectedFilter.source === "genderTypes"
                            ? search.name // Para género, usar el nombre para filtrar
                            : selectedFilter.source === "specialProtectionGroupTypes"
                              ? search.name // Para grupos especiales, usar el nombre para filtrar
                              : selectedFilter.source === "stateTypes"
                                ? search.name // Para estado, usar el nombre para filtrar
                                : selectedFilter.source === "statusTypes"
                                  ? search
                                  : selectedFilter.source === "errorTypes"
                                    ? search
                                    : selectedFilter.source === "severityTypes"
                                      ? search
                                      : selectedFilter.source === "enabledTypes"
                                        ? search
                                        : search.id
                : search.trim(),
        label: `${selectedFilter.visibleName}: ${selectedFilter.type === "date"
          ? `${dateFrom} - ${dateUntil}`
          : selectedFilter.type === "semester"
            ? `${semesterYear}-${semesterPeriod}`
            : selectedFilter.type === "select"
              ? selectedFilter.source === "subCategoryTypes"
                ? search?.map((item) => item.name).join(", ")
                : selectedFilter.source === "certifiableTypes"
                  ? search == "0"
                    ? "No"
                    : "Sí"
                  : selectedFilter.source === "statusTypes"
                    ? search
                    : selectedFilter.source === "errorTypes"
                      ? search
                      : selectedFilter.source === "severityTypes"
                        ? search
                        : selectedFilter.source === "genderTypes"
                          ? search?.name || "Sin especificar"
                          : selectedFilter.source === "specialProtectionGroupTypes"
                            ? search?.name || "Sin especificar"
                            : selectedFilter.source === "stateTypes"
                              ? search?.name || "Sin especificar"
                              : selectedFilter.source === "nodeStatus"
                                ? search?.name || "Sin especificar" // Para nodos, mostrar "Activo" o "Inactivo"
                                : selectedFilter.source === "nodeTypes"
                                  ? search?.name || "Sin especificar" // Para filtro de nodos, mostrar el nombre del nodo
                                  : selectedFilter.source === "authorTypes"
                                    ? search?.full_name || "Sin especificar" // Para filtro de autores, mostrar el nombre completo
                                    : selectedFilter.source === "enabledTypes"
                                      ? search
                                      : search?.name || "Sin especificar"
              : search.trim()
          }`,
      };

      let updatedFilters;
      const filterExists = filters.find((f) => f.type === newFilter.type);

      if (filterExists) {
        updatedFilters = filters.map((f) => (f.type === newFilter.type ? newFilter : f));
      } else {
        updatedFilters = [...filters, newFilter];
      }

      setFilters(updatedFilters);
      return updatedFilters;
    };

    //Borrar filtro almacenado en el arreglo de filtros
    const handleDeleteFilter = (id) => {
      const updatedFilters = filters.filter((item) => item.id !== id);
      setFilters(updatedFilters);

      if (updatedFilters.length === 0) {
        if (dataSourceId) {
          requestFilterPerIdFile(dataSourceId, currentPage, paginaSize, []);
        } else {
          requestFilter(currentPage, paginaSize, [], activity_id);
        }
      }

      // Limpieza visual
      setSearch("");
      setFilter("");
      setDateFrom("date");
      setDateUntil("date");
      setIsVisible(false);
      setIsVisibleType(false);
      setIsVisibleSelectDate(false);
      setIsVisibleSubcategory(false);
      setIsVisibleCertifiable(false);
      setIsVisibleCategory(false);
      setIsVisibleStatus(false);
      setIsVisibleErrorType(false);
      setIsVisibleSeverity(false);
      setIsVisibleGender(false);
      setIsVisibleSpecialProtectionGroup(false);
      setIsVisibleState(false);
      setIsVisibleSemester(false);
      setSemesterYear("");
      setSemesterPeriod("");
      setIsVisibleNode(false);
      setIsVisibleAuthor(false);
      setIsVisibleEnabled(false);
    };

    // Hace llamado a la funcion que realiza la peticion de los tipos de carnets y status cuando se renderiza el componente
    useEffect(() => {
      // requestCardType();
      // requestStatus();
      // requestSourceTypes();
      requestSubCategoriesList();
    }, []);

    // Hace llamado a la funcion que valida la data con los filtros actuales cuando la pagina actual cambia

    useEffect(() => {
      searchValidation(currentPage, paginaSize);
    }, [currentPage, filters]);

    //Esperar respuesta de la función getCardTypes y setear  el valor a dataTypeCard
    const requestCardType = async (pageIndex) => {
      const result = await getCardTypesWithoutPagination();
      if (result && result.status !== false) {
        const { payload } = result;
        await setDataTypeCard(payload);
      } else {
      }
    };

    //Esperar respuesta de la función getCardTypes y setear  el valor a dataTypeCard
    const requestSourceTypes = async (pageIndex) => {
      const result = await getSourceTypes();
      if (result && result.status !== false) {
        const { payload } = result;
        await setDataSourceTypes(payload);
      } else {
      }
    };

    //Esperar respuesta de la función getCardTypes y setear  el valor a dataTypeCard
    const requestStatus = async (pageIndex) => {
      const result = await getStatusTypes(pageIndex);
      if (result.status !== false) {
        const { data } = result;
        await setDataStatus(data);
      } else {
      }
    };

    //Esperar respuesta de la función CategoriesListAllService y setear el valor a SubCategoriesList
    const requestSubCategoriesList = async (pageIndex) => {
      setLoading(true);
      try {
        const result = await CategoriesListAllService();
        if (result.success) {
          setCategoriesList(result.payload);
          setSubCategoriesList(result.payload);
        } else {
          handleAlert("error", result.message);
        }
      } catch (error) {
        handleAlert("error", "Error al obtener las categorías");
      } finally {
        setLoading(false);
      }
    };

    /**
     * Maneja la selección de valores en los filtros de tipo select
     * Diferencia entre valores directos (string) y valores JSON que necesitan ser parseados
     * @param {Event} event - Evento del select
     */
    const handleFilterType = (event) => {
      const selectedValue = event.target.value;

      // Si no hay valor seleccionado, limpiar búsqueda
      if (selectedValue === "") {
        setSearch(selectedValue);
        handleChangeValid("search", true);
        return;
      }

      // Obtener el filtro actual para determinar el tipo de fuente
      const selectedFilter = filterConfig.find((f) => f.dbField === filter);

      // Para filtros de status, error type y severity, usar el valor directamente
      if (selectedFilter && (selectedFilter.source === "statusTypes" || selectedFilter.source === "errorTypes" || selectedFilter.source === "severityTypes")) {
        setSearch(selectedValue);
        handleChangeValid("search", true);
        return;
      }

      // Manejo especial para filtros de estado de nodos
      if (dataTable === "nodes" && filter === "active") {
        const numericValue = parseInt(selectedValue, 10);
        setSearch({ id: numericValue, name: numericValue === 1 ? "Activo" : "Inactivo" });
        handleChangeValid("search", true);
        return;
      }

      // Fuentes que usan valores directos (no requieren parsing JSON)
      const directValueSources = [
        "certifiableTypes",
        "enabledTypes",
        "statusTypes",
        "errorTypes",
        "severityTypes"
      ];

      // Si es una fuente de valor directo, usar el valor tal como viene
      if (selectedFilter && directValueSources.includes(selectedFilter.source)) {
        setSearch(selectedValue);
        handleChangeValid("search", true);
        return;
      }

      // Para otras fuentes (como categoryTypes, genderTypes, specialProtectionGroupTypes), intentar parsear como JSON
      try {
        const parsedValue = JSON.parse(selectedValue);
        setSearch(parsedValue);
        handleChangeValid("search", true);
      } catch (error) {
        // Si falla el parsing, usar el valor directo como fallback
        console.warn("No se pudo parsear como JSON, usando valor directo:", selectedValue);
        setSearch(selectedValue);
        handleChangeValid("search", true);
      }
    };

    //setear los valores digitados del primer filtro
    const handleChange = (event) => {
      event.preventDefault();
      handleChangeValid("search", true);
      const searchIsString = event.target.value;
      if (searchIsString.startsWith(" ")) return;
      setSearch(searchIsString.toString());
      if (filter === "") return;
    };

    //setear los cambios de fecha siempre y cuando la fecha "desde" no sea mayor a la de "hasta" y no este vacio el campo
    const handleChangeDateFrom = (event) => {
      handleChangeValid("date", true);
      if (event.target.value !== "") {
        const date = new Date(event.target.value);
        let formatDate = date.toISOString().slice(0, 10);
        if (dateUntil !== "" && dateUntil !== "date") {
          if (formatDate > dateUntil) {
            formatDate = dateUntil;
          }
        }
        setDateFrom(formatDate);
      } else {
        setDateFrom("date");
      }
    };

    //setear los cambios de fecha siempre y cuando la fecha "hasta" no sea menor a la de "desde" y no este vacio el campo
    const handleChangeDateUntil = (event) => {
      handleChangeValid("date", true);
      if (event.target.value !== "") {
        const date = new Date(event.target.value);
        let formatDate = date.toISOString().slice(0, 10);
        if (dateFrom !== "" && dateFrom !== "date") {
          if (formatDate < dateFrom) {
            formatDate = dateFrom;
          }
        }
        setDateUntil(formatDate);
      } else {
        setDateUntil("date");
      }
    };

    //Ejecutar funcion searchValidation con la página y filas para la tabla de carnets
    const handleClickSubmit = (params) => {
      let updatedFilters = handleAddFilter();

      if (!updatedFilters) updatedFilters = filters;

      const isReactEvent = params && typeof params === "object" && "_reactName" in params;

      if (isReactEvent) {
        searchValidation(currentPage, paginaSize, undefined, updatedFilters);
      } else {
        searchValidation(currentPage, paginaSize, params, updatedFilters);
      }
    };

    // Exponer handleClickSubmit al componente padre
    useImperativeHandle(ref, () => ({
      handleClickSubmit,
    }));

    // Validaciones -->

    // Variables de validacion
    const [isFieldValid, setIsFieldValid] = useState({
      search: true,
      date: true,
    });

    // Cambia el valor de la validacion entrante
    const handleChangeValid = (fieldName, isValid) => {
      setIsFieldValid((prevValidity) => ({
        ...prevValidity,
        [fieldName]: isValid,
      }));
    };

    // Setea el estado de todas las validaciones
    const resetFieldValid = () => {
      setIsFieldValid({
        search: true,
        date: true,
      });
    };

    //Setear nuevos valores para subcategorias
    const handleFieldChange = (name, value) => {
      setSearch(value);
      if (filter === "") return;
    };

    // Handlers para los filtros de semestre
    const handleSemesterYearChange = (event) => {
      setSemesterYear(event.target.value);
    };

    const handleSemesterPeriodChange = (event) => {
      setSemesterPeriod(event.target.value);
    };

    return (
      <>
        <Filter
          dataFilter={dataFilter}
          filterConfig={filterConfig}
          filter={filter}
          handleFilter={handleFilter}
          isVisible={isVisible}
          handleChange={handleChange}
          search={search}
          isVisibleSelectDate={isVisibleSelectDate}
          filterDate={filterDate}
          handleFilterType={handleFilterType}
          filterType={filterType}
          isVisibleDate={isVisibleDate}
          isVisibleType={isVisibleType}
          isVisibleSelectDateInput={isVisibleSelectDateInput}
          isVisibleSubcategory={isVisibleSubcategory}
          isVisibleCertifiable={isVisibleCertifiable}
          isVisibleEnabled={isVisibleEnabled}
          isVisibleCategory={isVisibleCategory}
          isVisibleStatus={isVisibleStatus}
          isVisibleErrorType={isVisibleErrorType}
          isVisibleSeverity={isVisibleSeverity}
          isVisibleGender={isVisibleGender}
          isVisibleSpecialProtectionGroup={isVisibleSpecialProtectionGroup}
          isVisibleState={isVisibleState}
          gendersList={gendersList}
          specialProtectionGroupsList={specialProtectionGroupsList}
          statesList={statesList}
          isVisibleNode={isVisibleNode}
          isVisibleAuthor={isVisibleAuthor}
          isVisibleSemester={isVisibleSemester}
          semesterYear={semesterYear}
          semesterPeriod={semesterPeriod}
          handleSemesterYearChange={handleSemesterYearChange}
          handleSemesterPeriodChange={handleSemesterPeriodChange}
          nodesList={nodesList}
          usersList={usersList}
          dateFrom={dateFrom}
          dateUntil={dateUntil}
          handleChangeDateFrom={handleChangeDateFrom}
          handleChangeDateUntil={handleChangeDateUntil}
          handleClickSubmit={handleClickSubmit}
          dataTypeCard={dataTypeCard}
          dataStatus={dataStatus}
          dataSourceTypes={dataSourceTypes}
          handleAddFilter={handleAddFilter}
          filters={filters}
          ShowErrorAlert={ShowErrorAlert}
          handleDeleteFilter={handleDeleteFilter}
          isFieldValid={isFieldValid}
          listSubCategories={subCategoriesList}
          categoriesList={categoriesList}
          handleFieldChange={handleFieldChange}
          dataTable={dataTable}
          getNodeStatusOptions={getNodeStatusOptions}
        />
      </>
    );
  }
);
export default FilterController;
